// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of, switchMap, take } from 'rxjs';
import { UserService } from '../../modules/portal/services/user.service';
import { AuthService } from 'src/app/modules/portal/services/authorize-service.service';

export const siemensHealthineersGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const authService = inject(AuthService);

  const DOMAIN = '@siemens-healthineers.com';

  return userService.userData$.pipe(
    take(1),
    switchMap(user => {

      if (!user?.mail?.endsWith(DOMAIN)) {
        userService.logout();
        return of(router.createUrlTree(['/login']));
      }

      return authService.checkUserAuthorization().pipe(
        map(isAuthorized => {

          const isUnauthorizedRoute = state.url.includes('/unauthorized');

          if (isAuthorized && isUnauthorizedRoute) {
            return router.createUrlTree(['/']);
          }

          if (!isAuthorized && !isUnauthorizedRoute) {
            return router.createUrlTree(['/unauthorized']);
          }
          return true;
        })
      );
    })
  );
};

